import type { ComponentPropsWithoutRef } from "react";
import { Suspense } from "react";

import { MemberChecklistLoading } from "@/react/components/MemberChecklist/MemberChecklistLoading";
import { lazyWithRetry } from "@/react/helpers/lazyRetry";

const MemberChecklistContent = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "MemberChecklistContent" */
    "@/react/components/MemberChecklist/MemberChecklistContent"
  ).then(module => ({ default: module.MemberChecklistContent })),
);

export const LazyMemberChecklistContent = (
  props: ComponentPropsWithoutRef<typeof MemberChecklistContent>,
) => (
  <Suspense fallback={<MemberChecklistLoading />}>
    <MemberChecklistContent {...props} />
  </Suspense>
);
